import { Minus, Plus } from 'lucide-react';
import { useState } from 'react';
import { SurveyQuestion } from '../types';

interface BeginRepeatInputProps {
  disabled?: boolean;
  label?: string;
  questions?: SurveyQuestion[];
  questionIndex?: number;
  getLabel: (obj: Record<string, any>) => string;
  renderQuestion: (q: SurveyQuestion, i: number, parentIndex?: number) => React.ReactElement;
}

const BeginRepeatInput = ({
  disabled = false,
  label = 'Repeat Group',
  questions = [],
  questionIndex,
  getLabel,
  renderQuestion,
}: BeginRepeatInputProps) => {
  const [items, setItems] = useState([1]);

  const addItem = () => {
    setItems([...items, Date.now()]);
  };

  const removeItem = (index: number) => {
    if (items.length > 1) {
      setItems(items.filter((_, i) => i !== index));
    }
  };

  return (
    <div className="space-y-4">
      {/* Group Label */}
      <h3 className="font-semibold text-[#C0275E]">{label}</h3>

      {/* Repeat Items */}
      {items.map((item, itemIndex) => (
        <div key={item} className="bg-gray-50 p-4 rounded-md space-y-4 relative">
          {/* Remove Button */}
          {items.length > 1 && (
            <button
              type="button"
              onClick={() => removeItem(itemIndex)}
              className="absolute right-3 bottom-3 border px-3 py-1"
            >
              <Minus size={14} />
            </button>
          )}

          {/* Questions */}
          {questions.map((q, i) => {
            const childLabel = getLabel(q);

            return (
              <div key={i} className="space-y-1">
                <h4 className="font-semibold text-[#C0275E]">
                  #{i + 1} {childLabel.replace(/^\d+\.\d+\s*/, '')}
                </h4>

                {renderQuestion(q, i, questionIndex)}
              </div>
            );
          })}
        </div>
      ))}

      {/* Add Button */}
      {!disabled && (
        <div className="flex justify-center">
          <button type="button" onClick={addItem} className="border px-3 py-1">
            <Plus size={16} />
          </button>
        </div>
      )}
    </div>
  );
};

export default BeginRepeatInput;
